import { hexToAlpha as constellationHexToAlpha } from '@zillow/constellation';
import { css } from 'styled-components';

const removeVar = /var\((.+)\)/;

export const getCssValue = (value: string) => {
  const documentStyles = window.getComputedStyle(document.documentElement);
  const propertyValue = value.replace(removeVar, '$1');

  // Older browsers (Chrome v97 for example) may return the property values with whitespace
  return documentStyles.getPropertyValue(propertyValue).trim() || value;
};

export const setCssVariable = (variable: string, value: string) => {
  variable = `--${variable}`;
  value = value === '' ? 'initial' : value;
  window?.document.documentElement.style.setProperty(variable, value);
};

export const hexToAlpha = (value: string, alpha: number) => {
  const resolvedValue = getCssValue(value);
  return constellationHexToAlpha(resolvedValue, alpha);
};

export const ellipsisMixin = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
